<template>
  <div class="apis-services q-py-lg">
    <dashboard-card
      icon="pause"
      color="deep-orange"
      title="Organization is Paused"
      action-label="Contact Support"
      style="max-width: 402px"
      class="q-mx-auto"
      @click="openIntercom"
    >
      <div class="q-mb-md">
        This organization has been paused since
        <b>{{ format(parseISO(user.pausedOn), 'MM/dd/yyyy') }}</b
        >.
      </div>
      <div class="q-my-md">
        Please contact your Organization owner or the customer support team.
      </div>
    </dashboard-card>
  </div>
</template>

<script lang="ts">
import { parseISO, format } from 'date-fns'
import DashboardCard from '@/components/DashboardCard.vue'

export default {
  name: 'OrganizationPaused',
  components: {
    DashboardCard
  },
  data() {
    return {}
  },
  computed: {
    user() {
      return this.$auth0.user.value
    }
  },
  methods: {
    parseISO,
    format,
    openIntercom() {
      this.$tracker.openedIntercom()
      Intercom('show')
    }
  }
}
</script>
<style scoped>
.verify-email {
  max-width: 1280px;
  margin: auto;
}
</style>
